
import HighWestLogo from '@/assets/svg/high-west-logo.svg'

export default {
  components: {
    HighWestLogo
  }
}
